import type { WLanguageVersionsTranslations } from "./pl";

export const en: WLanguageVersionsTranslations = {
  empty: "No languages configured.",
  ariaLabel: "Language selector",
  currentLanguageAria: (name) =>
    `Current language: ${name}. Click to change.`,
};
